















exports.default =

  props: ['custom_field']

  mixins: [require('../../helpers/form.coffee')]

  data: ->
    field: @custom_field.field

  computed:
    editabled: ->
      !@custom_field.editabled?

  methods:
    edit: ->
      @$emit('edit', Object.assign({}, @custom_field))

    destroyCustomField: ->
      @$emit('destroy', @custom_field)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/custom_fields/list_item.vue